export function hydrate(root) {
  // fallback to document if root is invalid
  if (!root || typeof root.querySelectorAll !== 'function') {
    root = document;
  }

  const sliders = root.querySelectorAll('slideshow-component');

  sliders.forEach((el) => {
    if (typeof el.initialize === 'function') {
      try {
        el.initialize();
      } catch (e) {
        console.warn('Slider init skipped', e);
      }
    }
  });

  return Promise.resolve();
}